import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Hidden from "@material-ui/core/Hidden";

const styles = (theme) => ({
  button: {
    margin: theme.spacing(0.4),
    color: "white",
    backgroundColor: "#fdba31",
    "&:hover": {
      color: "#white",
      backgroundColor: "#f9a029",
    },
  },
  login: {
    color: "#fff",
    "&:hover": {
      color: "#fdba31",
      backgroundColor: "inherit",
    },
  },
  loginMobile: {
    marginTop: "6px",
  },
  cluster: {
    marginRight: "1.7em",
    [theme.breakpoints.down("xs")]: {
      marginRight: "0em",
      marginTop: "6px",
    },
  },
});

const LoginButtons = (props) => {
  const { classes } = props;
  if (props.isLoggedIn) {
    return (
      <div className={classes.cluster}>
        <Button
          onClick={() => props.redirect("/private")}
          className={classes.login}
        >
          Dashboard
        </Button>
        <Hidden xsDown>
          <Button
            onClick={props.logout}
            variant="contained"
            className={classes.button}
          >
            Logout
          </Button>
        </Hidden>
      </div>
    );
  } else {
    return (
      <div>
        <Hidden xsDown>
          <div className={classes.cluster}>
            <Button
              onClick={() => props.redirect("/login")}
              className={classes.login}
            >
              Login
            </Button>
            <Button
              onClick={() => props.redirect("/register")}
              variant="contained"
              className={classes.button}
            >
              Sign up
            </Button>
          </div>
        </Hidden>
        <Hidden smUp>
          {" "}
          <Button
            onClick={() => props.redirect("/login")}
            className={classes.login + " " + classes.loginMobile}
            size="small"
          >
            Login
          </Button>
        </Hidden>
      </div>
    );
  }
};

export default withStyles(styles)(LoginButtons);
